module.exports = __webpack_public_path__ + "img/1557614060735897602.4e435018.png";